export default function /* @ngInject */ stripeValidateExpiryDate(stripeLoadSdk) {
    function link(scope, element, attrs, ngModel) {
        stripeLoadSdk().then((Stripe) => {

            ngModel.$validators.invalid_expiry = function (value) {
                return Stripe.card.validateExpiry(scope.exp_month, value);
            };

            attrs.$observe('stripeExpiryMonth', (value) => {
                scope.exp_month = value;
                ngModel.$validate();
            });
        });
    }

    return {
        require: 'ngModel',
        link: link
    };
}



// WEBPACK FOOTER //
// ./stripe/validators/stripe-validate-expiry-date.js